import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Check, Copy, Link2, Sparkles } from 'lucide-react';
import { buildReferralUrl } from '../../utils/referral';
import { useCopyReferralLink } from '../../hooks/useCopyReferralLink';
import { ReferralShareButtons } from './ReferralShareButtons';
interface ReferralLinkCardProps {
  referralCode: string | null;
  loading?: boolean;
}
export function ReferralLinkCard({
  referralCode,
  loading = false
}: ReferralLinkCardProps) {
  const url = buildReferralUrl(referralCode);
  const {
    copied,
    copy
  } = useCopyReferralLink(url);
  const unavailable = !referralCode;
  return <section aria-labelledby="referral-link-heading" className="relative overflow-hidden rounded-2xl border-2 border-[#FF0000]/40 bg-[#0A0A0A] p-6 shadow-[0_0_36px_rgba(255,0,0,0.12)] md:p-8" data-id="element-1794" data-mp="3ro3y8n6rfk36">
      <div className="mb-5 flex items-center gap-2" data-id="element-1795" data-mp="1xbe1lxp0bws3">
        <Link2 size={16} className="text-[#FF0000]" aria-hidden="true" data-id="element-1796" data-mp="21amyvcj9acse" />
        <h2 id="referral-link-heading" className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#FF0000]" data-id="element-1797" data-mp="2p9b8vxpcsv80">
          Your referral link
        </h2>
      </div>

      <div className="flex flex-col gap-3 lg:flex-row lg:items-center" data-id="element-1798" data-mp="2fjhz928ruq6e">
        <p className="min-w-0 flex-1 truncate rounded-xl border border-gray-800 bg-[#050505] px-4 py-4 font-mono text-sm text-gray-200" title={url} data-id="element-1799" data-mp="2fjrq0s1n51d5">
          {loading ? 'Loading your link…' : url}
        </p>
        <button type="button" onClick={copy} disabled={loading || unavailable} className="relative flex shrink-0 items-center justify-center gap-2 rounded-xl bg-[#FF0000] px-6 py-4 text-sm font-black uppercase tracking-wider text-white transition-colors duration-200 ease-out hover:bg-[#D90000] disabled:cursor-not-allowed disabled:opacity-60 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#050505]" data-id="element-1800" data-mp="339cchkx06gr6">
          {copied ? <Check size={16} aria-hidden="true" data-id="element-1801" data-mp="9w14nc3dq02l" /> : <Copy size={16} aria-hidden="true" data-id="element-1802" data-mp="dxw2g6m3pvbm" />}
          {copied ? 'Copied ✓' : 'Copy link'}
          <AnimatePresence data-id="element-1803" data-mp="3w3hdxgsg21xo">
            {copied && <motion.span aria-hidden="true" initial={{
            opacity: 0,
            scale: 0.96,
            y: 4
          }} animate={{
            opacity: 1,
            scale: 1,
            y: -14
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.25,
            ease: [0.23, 1, 0.32, 1]
          }} className="pointer-events-none absolute -top-1 right-2 text-[#FFD700]" data-id="element-1804" data-mp="3w2zao07d6ng9">
                <Sparkles size={14} data-id="element-1805" data-mp="33h65xl2icyqu" />
              </motion.span>}
          </AnimatePresence>
        </button>
      </div>

      <p className="mt-5 mb-3 font-mono text-[10px] uppercase tracking-[0.2em] text-gray-500" data-id="element-1806" data-mp="2orla1zc244y4">
        Share it
      </p>
      <ReferralShareButtons url={url} copied={copied} onCopy={copy} disabled={loading || unavailable} data-id="element-1807" data-mp="2kruny8xh6czx" />

      {unavailable && !loading && <p className="mt-4 text-xs text-gray-500" role="status" data-id="element-1808" data-mp="2tqy71cwn6sef">
          Your referral link is being prepared. Refresh in a moment.
        </p>}
    </section>;
}